export default {
  boutiqueList: {
    title: 'Boutiques',
    titleRestro: 'Boutique'
  },
  productsView: {
    title: "Produits",
    subtitle1: "Les produits de l'agence sont disponibles en caisse pleine.",
    subtitle2: 'Le nombre de bouteilles par caisse peut varier.',
    description: "Selon la loi régie par la SAQ, les produits vendus via l’Importation Privée sont seulement disponibles à la caisse.",
  },
  productView: {
    label: {
      available: 'Disponible',
      notAvailable: 'Épuisé',
      similarProducts: 'Produits similaires',
      privateAvailable: 'Dispo en privé',
      privateNotAvailable: 'Épuisé',
      reserved: 'Reserved',
    },
  },
  productCardComponent: {
    quantity: 'QTE',
    boxOf: 'Caisse (x{numberOfBottle})',
  },
  filters: {
    label: {
      selectedFilters: 'Filtres',
      all: 'Tout',
      headers: {
        typeOfProduct: 'Type',
        particularities: 'Couleur',
        availability: 'Entrepôts',
        product_status: 'Disponibilité',
        price: 'Prix',
        countryRegion: 'Origine',
      },
    },
    validation: {
      priceNovalue: 'Entrez une valeur',
      priceNotANumber: 'Valeur numérique attendue',
      priceLessThanZero: 'Valeur plus grande que zéro attendue',
    },
    button: {
      cancel: 'Annuler',
      filter: 'Filtrer',
    },
    noRecordsFound: 'Aucun résultats trouvés',
  },
  addToCart: {
    title: {
      price: 'Prix',
      taxLabel: {
        IN: 'Tax in',
        OUT: 'Tax ex',
      },
    },
    label: {
      addToCart: 'Ajouter au panier',
      howToOrder: 'Comment commander à la SAQ ?',
      availableInStore: 'Dispo en Boutique',
      purchase: '-15% pour 500$ d\'achat',
      notAvailable: 'Épuisé',
      purchaseMember: '-20% pour les membres"',
      quantity: 'Quantité',
      addedToCart: 'Ajoutée au panier',
      buy: 'Acheter',
      reserve: 'Réserve',
      reserved: 'Réservé',
    },
    labelDescription: {
      howToOrder: 'Vas sur le site de la SAQ au <a href="www.saq.com" style="color:#a31c25">www.saq.com</a> et sélectionne le produit désiré. Tu y trouveras les succursales qui tiennent le produit et le nombre de bouteilles disponibles. Tu pourras également y voir quels produits sont disponibles pour la vente en ligne et en livraison.',
      pickupInsaq: 'Conformément aux règles régies par la Saq, les produits vendus dans le cadre de l\'importation privée sont exclusivement disponibles en caisses complètes.',
    }
  },
  boutiqueProductsView: {
    title: "Boutique",
    subtitle1: "Les produits du boutique sont disponibles à l’unité, n’oublie pas d’ajouter un aliment dans ton panier.",
    subtitle2: '',
    description: 'Nos boutiques opèrent en tant que boutique et sont régies par la loi sur les permis d\'alcool. Pour plus d\'information, nous t\'invitons à consulter le texte de loi :<br><a target="_blank" href="https://www.legisquebec.gouv.qc.ca/fr/document/lc/p-9.1#:~:text=Le%20permis%20de%20boutique%20autorise%20aussi,pr%C3%A9par%C3%A9s" style="color:#a31c25"><b>P-9.1</b> - Loi sur les permis d’alcool</a>.'
  },
  boutiqueProductsQuebecView: {
    title: "Boutique de Québec",
    subtitle1: "Les produits du boutique sont disponibles à l’unité, n’oublie pas d’ajouter un aliment dans ton panier.",
    subtitle2: '',
    description: 'Nos boutiques opèrent en tant que boutique et sont régies par la loi sur les permis d\'alcool. Pour plus d\'information, nous t\'invitons à consulter le texte de loi :<br><a target="_blank" href="https://www.legisquebec.gouv.qc.ca/fr/document/lc/p-9.1#:~:text=Le%20permis%20de%20boutique%20autorise%20aussi,pr%C3%A9par%C3%A9s" style="color:#a31c25"><b>P-9.1</b> - Loi sur les permis d’alcool</a>.'
  },
  boutiqueProductsTorontoView: {
    title: "Restaurant Toronto",
    title1: "Boutique",
    subtitle1: "Les produits du boutique sont disponibles à l’unité, n’oublie pas d’ajouter un aliment dans ton panier.",
    subtitle2: '',
    description: 'Parce que c\'est la loi. Pour plus d\'information, nous t\'invitons a lire l\'article suivant:<br><a target="_blank" href="https://www.agco.ca/fr/bulletin/2020/bulletin-dinformation-points-forts-des-recentes-reformes-du-secteur-des-boissons#:~:text=les%20boutique%C2%A0locaux-,La%20vente%20pour%20emporter%20et%20la%20livraison%20de%20boissons%20alcoolis%C3%A9es%20avec,718%20pour%20les%20titulaires%20de%20permis%20de%20services%20de%20livraison%20d%E2%80%99alcool.,-Plusieurs%20modifications%20ont" style="color:#a31c25"><b>P-9.1</b> - Loi sur les permis d’alcool</a>.'
  },
  deliveryAddress: {
    montreal: 'Ramassage en boutique - Gratuit 6422 Boul. Saint-laurent, local 102 Montréal, QC - H2S 3C4',
    quebec: 'Ramassage en boutique - Gratuit 281 rue de la Couronne Québec, QC - G1K 6E2',
    toronto: 'Ramassage en boutique - Gratuit 1583 Dupont Toronto, ON, M6P 3S5'
  },
  pickupAddress: {
    montreal: 'Livraison chez vous - Frais de livraison en sus <br>Bientôt disponible',
    quebec: 'Livraison chez vous - Frais de livraison en sus <br>Bientôt disponible'
  },
  listTypeViewHeading: {
    title: 'No title',
    type: 'Type',
    disponibilité: 'Disponibilité',
    nom: 'Nom',
    cepage: 'Cépage',
    annee: 'Année',
    producteur: 'Producteur',
    production: 'Production',
    qte: 'Qté min.',
    prix: 'Prix',
    TBD: 'À venir',
    productCardComponent: {
      quantity: 'QTE',
      boxOf: '{numberOfBottle}',
    },
    volume: 'le volume'
  },
  nextBatche: {
    date: 'Date',
    Quantity: 'Quantité',
    name: 'Nom',
  },
  Apply: 'Appliquer',
  productAvailabilityTreeData: {
    IP: 'Import Privée'
  },
  productListView: {
    label: {
      available: 'Dispo',
      notAvailable: 'Épuisé',
    },
  },
  productAvailabilityTreeDataQc: [
    {
      id: 2,
      name: 'SAQ',
      code: 'SAQ',
    },
    {
      id: 3,
      name: 'IP',
      code: 'IP',
    },
    {
      id: 4,
      name: 'Boires',
      code: 'boires',
    },
  ],
  productAvailabilityStatusTree: [
    {
      id: 1,
      name: 'Disponible',
      code: 'AVAILABLE',
    },
    {
      id: 2,
      name: 'À Venir',
      code: 'UPCOMING',
    },
  ],
  productAvailabilityTreeDataOn: [
    {
      id: 2,
      name: 'LCBO',
      code: 'LCBO',
    },
    {
      id: 3,
      name: 'Consignment',
      code: 'PI',
    },
    {
      id: 4,
      name: 'Boires',
      code: 'STORE_TORONTO',
    },
  ],
  addToCartPopup: {
    title: 'Ajouté au panier',
    seeCart: 'Voir le panier',
    shopping: 'Continuer de magasiner',
    thanksMessage: 'Merci',
    reserveContent: 'Votre réservation sur un produit "à venir" a été envoyée à l’équipe de l’agence Boires. Vous serez contacté ultérieurement par courriel, pour confirmer cette réservation.'
  },
  reservePopup: {
    title: 'Ajoute aux réservations',
    subtitle: 'Je confirme que je souhaite réserver le vin à venir',
    reserveButton: 'Reserve',
    cancelButton: 'je ne souhaite pas réserver',
  },
  deliveryOption: 'Options de livraison',
  SaqPick: 'Ramassage en succursale Saq / Pick up in Saq boutique.',
  case: 'À la caisse'
};
